import type { ReactElement } from 'react'

import {
  type InputProps,
  TextAreaInputWrapper,
} from '../inputWrapper/InputWrapper'
import { createInternalWrapperPropsAndId } from '../utility'
import { RawTextArea, type RawTextAreaProps } from './RawTextArea'

export type TextAreaProps = RawTextAreaProps & InputProps<string | ReactElement>

export const TextArea = ({ wrapperProps, ...fieldProps }: TextAreaProps) => {
  const { internalWrapperProps, id } = createInternalWrapperPropsAndId({
    wrapperProps,
    id: fieldProps.id,
  })

  return (
    <TextAreaInputWrapper {...internalWrapperProps}>
      <RawTextArea {...fieldProps} id={id} />
    </TextAreaInputWrapper>
  )
}
